import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';
import { useAppContext } from 'src/components/app-context';
import { MediumUp, MobileOnly } from 'src/ui/block';

import { IconDropdownDown } from '@prisjakt/ui/icon/dropdown-down';
import { IconDropdownUp } from '@prisjakt/ui/icon/dropdown-up';
import { IconMenuKebab } from '@prisjakt/ui/icon/menu-kebab';

import { StyledExpandButton } from './styles';

interface IExpandButton {
  expanded?: boolean;
  onClick?: () => void;
  title?: string;
}

export const ExpandButton: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IExpandButton>>
> = ({ expanded = false, onClick }) => {
  const { showExpandButton } = usePriceRowContext();
  const { t } = useAppContext();
  const title = t('product', 'price.more-info');

  return (
    <StyledExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      title={title}
      data-test="ExpandButton"
      $hidden={!showExpandButton}
    >
      <MobileOnly>
        <IconMenuKebab color="base900" size={20} />
      </MobileOnly>
      <MediumUp>
        {expanded ? (
          <IconDropdownUp color="base900" size={20} />
        ) : (
          <IconDropdownDown color="base900" size={20} />
        )}
      </MediumUp>
    </StyledExpandButton>
  );
};
